import { useEffect, useState } from "react";
import Breadcrumb from "../../b-molecules/breadcrumb/Breadcrumb";
import Button from "../../b-molecules/buttons/Button";
import style from "./TitleBar.module.css";
import Label from "./Label";
import Icon from "../../a-atoms/icons/Icon";
import ManageLabels from "./ManageLabels";
import ContentEditable from "react-contenteditable";
import Sus from "./Sus";

const TitleBar = (props) => {
  const [showLabelDialog, setShowLabelDialog] = useState(false);
  const [labels, setLabels] = useState([]);

  function addLabel() {
    setShowLabelDialog(true);
  }
  function closeLabel() {
    setShowLabelDialog(false);
  }
  useEffect(() => {
    let tempArr = [];
    if (props.labels) {
      for (let i in props.labels) {
        tempArr.push({
          id: i,
          ...props.labels[i],
        });
      }
    }
    setLabels(tempArr);
  }, [props.labels]);

  function titleChangeHandler(e) {
    props.updateTitle(e)
  }

  // Handle paste events to strip HTML and only allow plain text
  function handlePaste(e) {
    e.preventDefault();
    const text = (e.clipboardData || window.clipboardData).getData('text/plain');
    // Remove newlines to keep it single line
    const singleLineText = text.replace(/\n/g, ' ').replace(/\r/g, '');
    document.execCommand('insertText', false, singleLineText);
  }

  // Prevent Enter key to keep title on single line
  function handleKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }

  function getScoreClass(score) {
    if (score === null || score === undefined) return "";
    if (score >= 80) return style.scoreExcellent;
    if (score >= 60) return style.scoreGood;
    if (score >= 40) return style.scoreOK;
    return style.scorePoor;
  }

  return (
    <div className={`${style.titleBar} ${props.darkMode ? style.darkMode : ''}`}>
      <div className={style.title}>
        <Breadcrumb items={props.breadcrumb} darkMode={props.darkMode} />
        <div className={style.header}>
          <h1>
            {props.editable ? (
              <ContentEditable
                html={props.title}
                onChange={(e) => titleChangeHandler(e)}
                onPaste={handlePaste}
                onKeyDown={handleKeyDown}
                inputMode="text"
              />
            ) : (
              props.title
            )}
          </h1>
          {props.headerExtra}
          {props.addLabels ? (
            <div className={style.labels}>
              {labels &&
                labels.map((label, index) => (
                  <Label
                    key={index}
                    editable={props.editable}
                    onRemoveLabel={props.onRemoveLabel}
                    data={label}
                    variants={["selected"]}
                  >
                    {label.value}
                  </Label>
                ))}
              {props.editable ? (
                <Icon onClick={props.editable && addLabel}>add</Icon>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
      <div className={style.actions}>
        <div className={style.users}>
        {props.owners && props.owners.length > 0 ? (
          <div className={style.userSet}><span>Owners</span><div className={style.container}>
            {props.owners &&
              props.owners.map((owner, index) => (
                <div
                  key={`owner-${owner.uid || index}`}
                  className={style.userAvatar}
                  // title={owner.name || owner.email || "Owner"}
                  title={owner.name}
                  style={
                    owner.photoURL
                      ? {
                        backgroundImage: `url(${owner.photoURL})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        color: "transparent",
                        opacity: owner.isAway ? 0.6 : 1,
                      }
                      : {
                        opacity: owner.isAway ? 0.6 : 1,
                      }
                  }
                >
                  {!owner.photoURL && owner.initials}

                </div>
              ))}</div></div>
            ) : null}
          {props.users && props.users.length > 0 ? (
            <div className={style.userSet}><span>Viewing</span><div className={style.container}>{props.users &&
              props.users.map((u, index) => (
                <div
                  key={`user-${index}`}
                  className={style.userAvatar}
                  title={u.name}
                  style={
                    u.photoURL
                      ? {
                        backgroundImage: `url(${u.photoURL})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        color: "transparent",
                        opacity: u.isAway ? 0.6 : 1,
                      }
                      : {
                        opacity: u.isAway ? 0.6 : 1,
                      }
                  }
                >
                  {!u.photoURL && u.initials}
                </div>
              ))}</div></div>
          ) : null}
        </div>
        {props.journeyScore !== null && props.journeyScore !== undefined ? (
          <div className={style.journeyScore} title="Journey Score">
            <span className={style.journeyScoreLabel}>UX Score: &nbsp;</span>
            <span className={`${style.journeyScoreValue} ${getScoreClass(props.journeyScore)}`}>
              {Math.round(props.journeyScore)}%
            </span>
          </div>
        ) : null}
        {props.sus ? <Sus sus={props.sus} showDetails={props.showSUSDetails} /> : null}
        {props.actions
          ? props.actions.map((action, index) => (
            <Button
              key={index}
              preIcon={action.icon}
              onClick={action.action}
              variants={action.variants}
            >
              {action.name}
            </Button>
          ))
          : null}
      </div>
      <ManageLabels
        show={showLabelDialog}
        onClose={closeLabel}
        currentLabels={labels}
        onAddLabel={props.onAddLabel}
        onRemoveLabel={props.onRemoveLabel}
      />
    </div>
  );
};

export default TitleBar;
